import { useParams } from 'react-router-dom'
import { Box } from '@mantine/core'

import { FinancialAnswers } from '@/modules/advisors/users/pages/[id]/components/FinancialAnswers/FinancialAnswers'
import { UserInfoHeader } from '@/modules/advisors/users/pages/[id]/components/UserInfoHeader/UserInfoHeader'

import { useAdvisorsServiceAdvisorUsersControllerGetUserById } from '@/__generated__/queries'

export function Component() {
  const { id: userId } = useParams<{ id: string }>()
  const numericUserId = userId ? +userId : 0

  const { data: user } = useAdvisorsServiceAdvisorUsersControllerGetUserById({
    userId: numericUserId,
  })

  if (!user) return null

  return (
    <Box>
      <UserInfoHeader user={user} userId={userId ?? ''} />

      <FinancialAnswers userId={numericUserId} />
    </Box>
  )
}

Component.displayName = 'Questionnaire'
